import { Routes } from "@angular/router";
import { ItemTypeListComponent } from './components/item-type-list/item-type-list.component';
import { ItemTypeEditComponent } from './components/item-type-edit/item-type-edit.component';
import { ItemListComponent } from './components/item-list/item-list.component';
import { ItemEditComponent } from './components/item-edit/item-edit.component';
import { ItemDashboardComponent } from './components/item-dashboard/item-dashboard.component';
import { ScheduleListComponent } from './components/schedule-list/schedule-list.component';
import { ScheduleEditComponent } from './components/schedule-edit/schedule-edit.component';
import { UserStatusComponent } from './components/user-status/user-status.component';

export const moduleRoutes: Routes = [
    {
        path: '',
        component: ItemDashboardComponent
    },
    {
        path: 'status',
        component: UserStatusComponent
    },
    {
        path: 'types',
        component: ItemTypeListComponent
    },
    {
        path: 'types/add',
        component: ItemTypeEditComponent
    },
    {
        path: 'types/edit/:id',
        component: ItemTypeEditComponent
    },
    {
        path: 'items',
        component: ItemListComponent
    },
    {
        path: 'items/add',
        component: ItemEditComponent
    },
    {
        path: 'items/edit/:id',
        component: ItemEditComponent
    },
    {
        path: 'schedules',
        component: ScheduleListComponent
    },
    {
        path: 'schedules/add',
        component: ScheduleEditComponent
    },
    {
        path: 'schedules/edit/:id',
        component: ScheduleEditComponent
    }    
]